import ENVIRONMENT_CONSTANTS from './ENVIRONMENT-CONSTANTS';
import { Build } from '@stencil/core';

interface EnvLocation {
  host: string;
  pathname: string;
}

/**
 * Returns boolean if environment is PRODUCTION
 *
 * @returns boolean
 */
export const isProduction = (location: EnvLocation) => {
  if (location) {
    if (
      location.host === 'testing.stenciljs.com'
      || location.host.indexOf('localhost') >= 0
      || location.host.indexOf('healthpartners.int') >= 0
      || location.pathname.indexOf('hpwc-dev') >= 0
      || location.host.match(/webdev[0-9]/)
      || location.host.match(/webuat[0-9]/)
    ) {
      return false;
    }
  }
  return true;
};

/**
 * Returns boolean if environment is DEVELOPMENT
 */
export const isDevelopment = (location: EnvLocation) => Build.isDev && !isProduction(location);

/**
 * Returns boolean if environment is LOCALHOST
 */
export const isLocalhost = (location: EnvLocation) => {
  if (
    location.host.indexOf('localhost') >= 0
    || location.host.indexOf('healthpartners.int') >= 0
  ) {
    return true;
  }

  return false;
};

/**
 * Returns boolean if "*storybook/*" is in the url
 */
export const isStorybook = (location: EnvLocation) => {
  if (location.pathname.match('storybook/')) {
    return true;
  }

  return false;
};

export const isTest = () => {
  return Build.isTesting;
};

/**
 * Returns one of the ENVIRONMENT_CONSTANTS: LOCALHOST, DEVELOPMENT, PRODUCTION
 */
export default () => {
  if (isLocalhost(document.location)) {
    return ENVIRONMENT_CONSTANTS.LOCALHOST;
  }

  if (isProduction(document.location)) {
    return ENVIRONMENT_CONSTANTS.PRODUCTION;
  }

  return ENVIRONMENT_CONSTANTS.DEVELOPMENT;
};
